module.exports = __webpack_public_path__ + "img/spreaker_icon.716d7020.png";